module.exports = __webpack_public_path__ + "img/9791186490266.f2d20d4b.jpg";